import { useContext, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import StudentDashboardShell from '../components/studentDashboard/StudentDashboardShell';
import useStudentNotifications from '../hooks/useStudentNotifications';
import '../styles/notifications.css';

export default function StudentNotificationsPage() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const authUser = user?.user || user;
  const role = authUser?.role || user?.role;
  const email = authUser?.email || '';
  const displayName = authUser?.name || 'Student';
  const avatarLetter = (displayName || '?').trim().charAt(0).toUpperCase();

  const { history, loading, error, loadHistory, markAllRead, unreadCount } =
    useStudentNotifications({ enabled: role === 'student', pollMs: 0 });

  useEffect(() => {
    if (role === 'student') loadHistory();
  }, [role, loadHistory]);

  if (!user?.token && !authUser) {
    return <Navigate to="/" replace />;
  }
  if (role && role !== 'student') {
    return <Navigate to="/dashboard" replace />;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <StudentDashboardShell
      displayName={displayName}
      email={email}
      avatarLetter={avatarLetter}
      onLogout={handleLogout}
    >
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-semibold" style={{ color: 'var(--color-text)' }}>
            Notifications
          </h2>
          <p className="notif-muted">Your full message history across channels</p>
        </div>
        <div className="notif-actions" style={{ marginTop: 0 }}>
          <button
            type="button"
            className="notif-btn"
            onClick={() => navigate('/student/dashboard')}
          >
            Dashboard
          </button>
          {unreadCount > 0 ? (
            <button type="button" className="notif-btn notif-btn-primary" onClick={markAllRead}>
              Mark all read
            </button>
          ) : null}
        </div>
      </div>

      {error ? <p className="notif-muted" style={{ color: '#b91c1c' }}>{error}</p> : null}
      {loading ? <p className="notif-muted">Loading…</p> : null}

      {!loading && history.length === 0 ? (
        <p className="notif-muted">No notifications yet.</p>
      ) : null}

      {history.map((row) => (
        <article key={row.id} className="notif-history-card">
          <div className="flex flex-wrap items-center gap-2 mb-1">
            <h3>{row.campaign?.subject || 'Notification'}</h3>
            <span className="notif-status">{row.channel}</span>
            <span className="notif-status">{row.status}</span>
          </div>
          <p className="notif-muted" style={{ margin: '0 0 0.5rem' }}>
            {row.createdAt ? new Date(row.createdAt).toLocaleString() : ''}
            {row.campaign?.createdBy
              ? ` · from ${row.campaign.createdBy.firstName || ''} ${
                  row.campaign.createdBy.lastName || ''
                }`.trimEnd()
              : ''}
          </p>
          <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{row.campaign?.body}</p>
          {row.errorMessage ? (
            <p className="notif-muted" style={{ color: '#b91c1c', marginTop: '0.5rem' }}>
              {row.errorMessage}
            </p>
          ) : null}
        </article>
      ))}
    </StudentDashboardShell>
  );
}
